import { render } from "./QuestionMark.vue?vue&type=template&id=79779112&scoped=true"
const script = {}

import "./QuestionMark.vue?vue&type=style&index=0&id=79779112&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79779112"]])

export default __exports__